import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "../../css/UniversityPosts.module.css"; // Use the same style as Dashboard

const UniversityPosts = () => {
  const [universityPostedJobs, setUniversityPostedJobs] = useState([]);
  const [repostedJobs, setRepostedJobs] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [company, setCompany] = useState("");
  const [location, setLocation] = useState("");
  const [requirements, setRequirements] = useState("");
  const [jobType, setJobType] = useState("");
  const [sortField, setSortField] = useState(""); // State for sorting field
  const [sortOrder, setSortOrder] = useState("asc"); // State for sort order
  

  const navigate = useNavigate(); // For navigation

  useEffect(() => {
    fetchUniversityJobs();
  }, []);
  
  useEffect(() => {
    handleSearch();
  }, [sortField, sortOrder]); // Re-run search when sorting options change

  const handleSearch = async () => {
    try {
      setLoading(true);
      setError("");
      const token = localStorage.getItem("token");
      const queryParams = new URLSearchParams();
      if (searchTerm) queryParams.append("title", searchTerm);
      if (company) queryParams.append("company", company);
      if (location) queryParams.append("location", location);
      if (requirements) queryParams.append("requirements", requirements);
      if (jobType) queryParams.append("jobType", jobType);
      if (sortField) queryParams.append("sortField", sortField); // Add sortField
      if (sortOrder) queryParams.append("sortOrder", sortOrder); // Add sortOrder

      const response = await axios.get(
        `https://techservicemarket-backend.onrender.com/api/users/university/posts?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUniversityPostedJobs(response.data.filter(job => (job.universityPartnerId && job.originalJobId === null)));
      setRepostedJobs(response.data.filter((job) => job.originalJobId));   
      setLoading(false);
    } catch (error) {
      console.error("Error searching jobs:", error);
    }
  };
  const fetchUniversityJobs = async () => {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("token");
      const queryParams = new URLSearchParams();
      if (searchTerm) queryParams.append("title", searchTerm);
      if (company) queryParams.append("company", company);
      if (location) queryParams.append("location", location);
      if (requirements) queryParams.append("requirements", requirements);
      if (jobType) queryParams.append("jobType", jobType);
      if (sortField) queryParams.append("sortField", sortField); // Add sortField
      if (sortOrder) queryParams.append("sortOrder", sortOrder); // Add sortOrder

      const response = await axios.get(
        `https://techservicemarket-backend.onrender.com/api/users/university/posts?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setUniversityPostedJobs(response.data.filter(job => (job.universityPartnerId && job.originalJobId === null)));
      setRepostedJobs(response.data.filter((job) => job.originalJobId));      
    } catch (error) {
      console.error("Error fetching university jobs:", error);
      setError("Failed to fetch university jobs. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSortChange = (field) => {
    // Toggle sort order if the same field is selected, otherwise reset to ascending
    if (sortField === field) {
      setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const JobCard = ({ job }) => (
    <div
      className={styles.jobCard}
      onClick={() => navigate(`/dashboard/jobs/${job._id}`)} // Navigate to the application page
      style={{ cursor: "pointer" }} // Add cursor pointer for better UX
    >
      <h3>{job.title}</h3>
      <p>
        <strong>Company:</strong> {job.company || "Unknown"}
      </p>
      <p>
        <strong>Location:</strong> {job.location || "Not specified"}
      </p>
      <p>
        <strong>Salary:</strong> {job.salary ? `$${job.salary}` : "Not specified"}
      </p>
      <p>
        <strong>Job Type:</strong> {job.jobType || "Not specified"}
      </p>
      <p>
        <strong>Description:</strong> {job.description || "No description available"}
      </p>
      <p>
        <strong>Skills Required:</strong> {job.requirements?.join(", ") || "None"}
      </p>
      <p>
        <strong>Date Posted:</strong> {new Date(job.createdAt).toLocaleDateString()}
      </p>
    </div>
  );

  return (
    <div className={styles.dashboardContainer}>
      <button
        onClick={() => navigate("/dashboard")}
        className={styles.backButton}
      >
        ← Back to Dashboard
      </button>
      <h1 className={styles.dashboardHeader}>University Posts</h1>
      {loading && <p>Loading jobs...</p>}
      {!loading && error && <p className={styles.errorText}>{error}</p>}
               {/* Search Section */}
               <div className={styles.searchSection}>
          <input
            type="text"
            placeholder="Search by Title"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
          <input
            type="text"
            placeholder="Search by Company"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            className={styles.searchInput}
          />
          <input
            type="text"
            placeholder="Search by Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className={styles.searchInput}
          />
          <input
            type="text"
            placeholder="Requirements (comma-separated)"
            value={requirements}
            onChange={(e) => setRequirements(e.target.value)}
            className={styles.searchInput}
          />
          <select
            value={jobType}
            onChange={(e) => setJobType(e.target.value)}
            className={styles.selectInput}
          >
            <option value="">Select Job Type</option>
            <option value="Full-time">Full-time</option>
            <option value="Part-time">Part-time</option>
            <option value="Contract">Contract</option>
            <option value="Internship">Internship</option>
          </select>
          <button onClick={handleSearch} className={styles.searchButton}>
            Search
          </button>
        </div>

{/* Sorting Options */}
      <div className={styles.sortSection}>
        <button
          onClick={() => handleSortChange("salary")}
          className={styles.sortButton}
        >
          Sort by Salary {sortField === "salary" && (sortOrder === "asc" ? "(less)" : "(more)")}
        </button>
        <button
          onClick={() => handleSortChange("requirements")}
          className={styles.sortButton}
        >
          Sort by Requirements {sortField === "requirements" && (sortOrder === "asc" ? "(less)" : "(more)")}
        </button>
        <button
          onClick={() => handleSortChange("createdAt")}
          className={styles.sortButton}
        >
          Sort by Job Posted {sortField === "createdAt" && (sortOrder === "asc" ? "(old to new)" : "(new to old)")}
        </button>
      </div>
      {!loading && !error && (
        <div className={styles.jobSectionsContainer}>
          {/* University Posted Jobs Section */}
          <div className={styles.jobSection}>
            <h2>University-Posted Jobs</h2>
            {universityPostedJobs.length > 0 ? (
              <div className={styles.jobCardsContainer}>
                {universityPostedJobs.map((job) => (
                  <JobCard key={job._id} job={job} />
                ))}
              </div>
            ) : (
              <p>No university-posted jobs found.</p>
            )}
          </div>

          {/* Reposted Jobs Section */}
          <div className={styles.jobSection}>
            <h2>Reposted Jobs</h2>
            {repostedJobs.length > 0 ? (
              <div className={styles.jobCardsContainer}>
                {repostedJobs.map((job) => (
                  <JobCard key={job._id} job={job} />
                ))}
              </div>
            ) : (
              <p>No reposted jobs found.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UniversityPosts;
